import { request } from './client';

export interface EmailPreferences {
  id: string;
  userId: string;
  welcomeEmails: boolean;
  boardInvites: boolean;
  boardCompletions: boolean;
  winnerNotifications: boolean;
  squareRequestUpdates: boolean;
  userJoinedBoardAlerts: boolean;
  referralRewardAlerts: boolean;
  lowCreditsAlerts: boolean;
  marketingEmails: boolean;
  weeklyReports: boolean;
  mergeRequestAlerts: boolean;
  unsubscribedFromAll: boolean;
  updatedAt: string;
}

export type UpdateEmailPreferencesInput = Partial<
  Omit<EmailPreferences, 'id' | 'userId' | 'updatedAt'>
>;

export const emailPreferencesApi = {
  async getPreferences(): Promise<EmailPreferences> {
    return request<EmailPreferences>('/api/squareup/email/preferences');
  },

  async updatePreferences(input: UpdateEmailPreferencesInput): Promise<EmailPreferences> {
    return request<EmailPreferences>('/api/squareup/email/preferences', {
      method: 'PUT',
      body: input,
    });
  },
};
